import { Box, Dialog, DialogContent, Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'
import Profile from './Profile'
import SuccessTracker from './SuccessTracker'
import Centurion from '../Centurion/Centurion'
import { storeElement } from 'GlobalStores/StoreElement'

const AchievementModal = observer(({ open, onClose, customerId }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            PaperProps={{
                sx: {
                    maxHeight: '90vh',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    margin: storeElement.IsMobile() ? '16px' : 'inherit',
                    width: storeElement.IsMobile() ? 'calc(100% - 16px)' : 'inherit',
                }
            }}>
            <DialogContent sx={{ padding: '0px' }}>
                {storeElement.IsMobile() ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            alignItems: 'stretch',
                            justifyContent: 'center'
                        }}>
                        <Box sx={{ flex: { xs: '1', md: '0 0 350px' } }}>
                            <Profile customerId={customerId} />
                        </Box>
                        <Box sx={{ flex: { xs: '1', md: '0 0 400px' } }}>
                            <SuccessTracker customerId={customerId} />
                        </Box>
                        <Box sx={{ flex: { xs: '1', md: '0 0 400px' } }}>
                            <Centurion customerId={customerId} />
                        </Box>
                    </Box>
                ) : (
                    <Stack
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 398px)',
                            gap: '16px',
                            justifyContent: 'center',
                            alignItems: 'start'
                        }}>
                        <Profile customerId={customerId} />
                        <SuccessTracker customerId={customerId} />
                        <Centurion customerId={customerId} />
                    </Stack>
                )}
            </DialogContent>
        </Dialog>
    )
})

export default AchievementModal
